module.exports = __webpack_public_path__ + "img/client-3.909565f7.png";